document.addEventListener("DOMContentLoaded", () => {
  // 1) Grab _your_ hover-popup container
  const popupContainer = document.querySelector(".mini-cart-container");
  if (!popupContainer) {
    console.warn("No .mini-cart-container found – check your header.liquid");
    return;
  }

  // 2) Inside it, grab the items & subtotal
  const miniCartItems      = popupContainer.querySelector(".mini-cart-items");
  const cartSubtotalSpan   = popupContainer.querySelector(".cart-subtotal");
  // (Cart count bubble is global, that's fine)
  const cartCountSpan      = document.querySelector(".cart-count-bubble span");

  if (!miniCartItems) {
    console.warn("No .mini-cart-items inside your popup – check your HTML");
    return;
  }
  if (!cartSubtotalSpan) {
    console.warn("No .cart-subtotal inside your popup – check your HTML");
  }

  // 3) Fetch & render
  function refreshCart() {
    fetch("/cart.js")
      .then(r => r.json())
      .then(cart => {
        // ── ITEMS ─────────────────────────────────────────
        if (cart.items.length === 0) {
          miniCartItems.innerHTML = "<p>Your cart is empty.</p>";
        } else {
          miniCartItems.innerHTML = cart.items
            .map(item => `
              <div class="mini-cart-item">
              <a href="${item.url}">
                <img src="${item.image}" alt="${item.title}" />
              </a>
                <div>
                  <p><strong><a href="${item.url}">${item.product_title}</a></strong></p>
                  <p>Qty: ${item.quantity}</p>
                  <p>Price: $${(item.price/100).toFixed(2)}</p>
                </div>
              </div>
            `).join("");
        }

        // ── COUNT BUBBLE ─────────────────────────────────
        if (cartCountSpan) {
          cartCountSpan.textContent = cart.item_count;
        }

        // ── SUBTOTAL ────────────────────────────────────
        // prefer pre-tax `items_subtotal_price`, fallback to `total_price`
        const cents = cart.items_subtotal_price ?? cart.total_price;
        if (cartSubtotalSpan) {
          cartSubtotalSpan.textContent = (cents / 100).toFixed(2);
        }
      })
      .catch(err => {
        console.error("Error fetching /cart.js:", err);
        miniCartItems.innerHTML = "<p>Error loading cart.</p>";
      });
  }

  // 4) Initial load
  refreshCart();

  // 5) Live-update when any variant/add-to-cart form submits
  // document.body.addEventListener("submit", e => {
  //   // target forms with action="/cart/add" (Dawn product forms)
  //   if (!e.target.matches('form[action^="/cart/add"]')) return;
  //   e.preventDefault();
  //   fetch("/cart/add.js", {
  //     method: "POST",
  //     body: new FormData(e.target),
  //   })
  //     .then(() => refreshCart())
  //     .catch(err => console.error("Add to cart failed:", err));
  // });

  const cartDrawer = document.querySelector('#CartDrawer');

if (cartDrawer) {
  const observer = new MutationObserver(() => {
    setTimeout(() => refreshCart(), 200);
  });

  observer.observe(cartDrawer, { childList: true, subtree: true });
}
});
